$(document).ready(function(){
  if (document.body.clientWidth < 1000) {
    $(".product-info__block-item[data-block-type=title]").insertBefore(".product-gallery");
    $(".product-info__block-item[data-block-type=price]").insertAfter(".product-info__block-item[data-block-type=variant-picker]");
    } else { 
    $(".product-info__block-item[data-block-type=title]").insertBefore(".product-info__block-item[data-block-type=price]");
    $(".product-info__block-item[data-block-type=price]").insertBefore(".product-info__block-item[data-block-type=liquid]");
  }


$(".accordion-group .accordion:eq(0)").addClass('active');
$(".accordion.group.active .accordion__content").show();   
  
   $(".accordion .accordion__toggle").click(function(){
   $(".accordion.group").removeClass('active');
   $(this).parent().closest('.accordion').toggleClass('active');
   $(".accordion.group .accordion__content").hide();
   $(".accordion.group.active .accordion__content").show(); 
   });
});

// Index Slideshow Random Slide Change Js Start
 
  var slideshowtotal = $('.cm_slide_show .slideshow__slide').length;
  var slideshowrandimg = Math.floor(Math.random() * slideshowtotal);

  $('.cm_slide_show').slick({
    initialSlide: slideshowrandimg,
    arrows: false,
    fade: true,
    infinite: true,
    pauseOnHover: false,
    draggable: false,
    accessibility:true,
    adaptiveHeight: true,
    swipe: false,
    touchMove: false
    });

// Index Slideshow Random Slide Change Js End

// Header Logo Text Random Slide Change Js Start
 
  var desklogototalslide = $('.desk_menu_logo_slider .desk_menu_logo_slide').length;
  var desklogorandtext = Math.floor(Math.random() * desklogototalslide);

  $('.desk_menu_logo_slider').slick({
    initialSlide: desklogorandtext,
    arrows: false,
    fade: true,
    infinite: true,
    pauseOnHover: false,
    accessibility:true,
    adaptiveHeight: true,
    draggable: false,
    swipe: false,
    touchMove: false
    });

// Header Logo Text Random Slide Change Js End

// Mobile Menu Drawer Logo Text Random Slide Change Js Start

  var mobilelogototalslide = $('.mobile_menu_logo_slider .mobile_menu_logo_slide').length;
  var mobilelogorandtext = Math.floor(Math.random() * mobilelogototalslide);

  $('.mobile_menu_logo_slider').slick({
    initialSlide: mobilelogorandtext,
    arrows: false,
    fade: true,
    infinite: true,
    pauseOnHover: false,
    accessibility:true,
    adaptiveHeight: true,
    draggable: false,
    swipe: false,
    touchMove: false
    });

  $('.mb_show').click(function(){
   // $(".cm_logo_text_slider.sidebar_nav").slick("resize");
  $('.cm_logo_text_slider.sidebar_nav')[0].slick.refresh()
  });

// Mobile Menu Drawer Logo Text Random Slide Change Js End
